module.exports = __webpack_public_path__ + "static/media/MorphNeon_Trans.05cbc04d.png";